import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://odretsyskzibqncslaqb.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9kcmV0c3lza3ppYnFuY3NsYXFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzOTE4OTEsImV4cCI6MjA2ODk2Nzg5MX0.S5gcF2qL8o1hbtwu0TnvnGRVBrAvafKNMnFJKtchPI0';

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});